import { useLazyQuery } from '@apollo/client';
import { useEffect, useMemo } from 'react';
import { FETCH_SUB_TRADE_REQUESTS_FULL } from '../queries';
import type { PortfolioReport, SubTradeRequest } from '../types';
import type { PendingTradesState } from '../utils/portfolioRevampBuilders';

export function usePendingTradesForReport(
  report: PortfolioReport,
): PendingTradesState {
  const [
    fetchPendingTrades,
    {
      data: pendingTradesData,
      loading: pendingTradesLoading,
      called: pendingTradesCalled,
    },
  ] = useLazyQuery(FETCH_SUB_TRADE_REQUESTS_FULL, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });

  const pendingTrades: SubTradeRequest[] =
    pendingTradesData?.fetchSubTradeRequests?.subTradeRequests || [];

  useEffect(() => {
    const isGoal = report.modelPortfolioType === 'GOAL';
    const objectId = report.object?.id;
    if (!objectId) return;
    fetchPendingTrades({
      variables: {
        input: {
          filter: {
            ...(isGoal ? { goalId: objectId } : { subAccountId: objectId }),
            states: ['INITIATED', 'READY', 'REQUESTED'],
          },
          pagination: { perPage: 50, offSet: 0 },
        },
      },
    });
  }, [report.object?.id, report.modelPortfolioType, fetchPendingTrades]);

  return useMemo(
    () => ({ pendingTrades, pendingTradesCalled, pendingTradesLoading }),
    [pendingTrades, pendingTradesCalled, pendingTradesLoading],
  );
}
